import React, { Fragment } from "react"
import "./src/assets/main.scss"
import DataCollect from "./src/data/data-collect"
import "./src/fontello/css/fontello.css"
import axios from "axios"
import MaintenanceProvider, {
  MaintenanceContext,
} from "./src/context/MaintenanceContext"
import MaintenancePage from "./src/components/MaintenancePage/MaintenancePage"

let isLoginInProgress = false
let loginPromise = null

const getToken = () => {
  return localStorage.getItem("token")
}

const ensureToken = async () => {
  const existingToken = getToken()
  if (existingToken) return existingToken

  if (isLoginInProgress && loginPromise) return await loginPromise

  isLoginInProgress = true
  loginPromise = fetch(`${process.env.GATSBY_PROXY_URL || "https://preprodproxy.efpa.es/"}token/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      username: process.env.GATSBY_DEFAULT_USERNAME || "000333X",
      password: process.env.GATSBY_DEFAULT_PASSWORD || "000333X"
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.access) {
      localStorage.setItem("token", data.access)
      return data.access
    }
    throw new Error("TOKEN_NOT_AVAILABLE")
  })
  .finally(() => {
    isLoginInProgress = false
    loginPromise = null
  })

  return await loginPromise
}

const setupGlobalInterceptors = () => {
  if (typeof window === "undefined") return

  // Interceptar axios
  const originalCreate = axios.create.bind(axios)
  axios.create = function(config) {
    const instance = originalCreate(config)
    instance.interceptors.request.use(
      async cfg => {
        const token = await ensureToken().catch(() => null)
        if (token) {
          cfg.headers = cfg.headers || {}
          if (!cfg.headers.Authorization) {
            cfg.headers.Authorization = "Bearer " + token
          }
        }
        return cfg
      },
      error => Promise.reject(error)
    )
    return instance
  }

  const originalRequest = axios.request.bind(axios)
  axios.request = async function(cfg) {
    const token = await ensureToken().catch(() => null)
    if (token) {
      cfg.headers = cfg.headers || {}
      if (!cfg.headers.Authorization) {
        cfg.headers.Authorization = "Bearer " + token
      }
    }
    return originalRequest(cfg)
  }

  const methods = ['get', 'post', 'put', 'delete', 'patch', 'head', 'options']
  methods.forEach(method => {
    const originalMethod = axios[method].bind(axios)
    axios[method] = async function(url, config) {
      const token = await ensureToken().catch(() => null)
      if (token) {
        config = config || {}
        config.headers = config.headers || {}
        if (!config.headers.Authorization) {
          config.headers.Authorization = "Bearer " + token
        }
      }
      return originalMethod(url, config)
    }
  })
}

export const wrapRootElement = ({ element }) => {
  DataCollect.init()
  setupGlobalInterceptors()
  // MaintenanceProvider es el wrapper más externo: debe resolver el estado
  // antes que los interceptors de axios añadan auth a cualquier petición
  return (
    <MaintenanceProvider>
      <Fragment>{element}</Fragment>
    </MaintenanceProvider>
  )
}

export const wrapPageElement = ({ element }) => (
  // Context.Consumer en lugar de useContext(): wrapPageElement no es un
  // componente funcional estándar de React, por lo que los hooks no están garantizados
  <MaintenanceContext.Consumer>
    {({ isInMaintenance, isLoading }) => {
      if (isLoading) return <div className="maintenance-loading" />
      if (isInMaintenance) return <MaintenancePage />
      return element
    }}
  </MaintenanceContext.Consumer>
)

